import session from '@api/session'
import { APIEndpoint } from '@api/_version'

export default {
  getAllWidgetTemplates(params = {}) {
    // Pass the params (which might include template_theme) to the GET request.
    return session.get(APIEndpoint + '/api/widget-templates/', { params })
  },
  createWidgetTemplate(data) {
    return session.post(APIEndpoint + '/api/widget-templates/', data)
  },
  updateWidgetTemplate(id, data) {
    return session.put(APIEndpoint + '/api/widget-templates/' + id + '/', data)
  },
}